module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header",
    class: _vm.classObject,
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "nav-wrap"
  }, [_c('img', {
    staticClass: "header-logo",
    attrs: {
      "src": require("../assets/img/logo1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav clearfix"
  }, [_c('li', {
    class: {
      'active': _vm.activeType === 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home',
        params: {
          status: 1
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeType === 2
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Teacher',
        params: {
          status: 2
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("老师")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeType === 3
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Student',
        params: {
          status: 3
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("学生")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeType === 4
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Parent',
        params: {
          status: 4
        }
      }
    },
    on: {
      "click": _vm.handleNavClick
    }
  }, [_vm._v("家长")])], 1), _vm._v(" "), _c('li', {
    staticClass: "down-scan"
  }, [_c('div', {
    staticClass: "app-down-warn",
    on: {
      "mouseover": function($event) {
        _vm.showScanErma = true
      },
      "mouseout": function($event) {
        _vm.showScanErma = false
      }
    }
  }, [_c('img', {
    staticClass: "phone-icon",
    attrs: {
      "src": require("../assets/images/icon-phone.png"),
      "alt": ""
    }
  }), _vm._v("App下载\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScanErma),
      expression: "showScanErma"
    }],
    staticClass: "scan-erma"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/app-qr.png"),
      "alt": ""
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e223cc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 509
// module chunks = 2